<template lang="pug">
box
  page-title(slot="page-title", title="Documento")
  .scrollable(slot="content")
    .p-2
      load-manager(:loading="loading")
        div(v-if="current")
          section.top-header
            .columns
              .column
                .my-1 {{ current | enums("doc.tipo") }} #[b {{ current.numero }}/{{ current.ano }}]
                label.label {{ current.situacao.descricao }}
              .column.col-auto.text-right
                a.btn.btn-link(:href="current.url", target="_blank")
                  i.fa.fa-print
                  |
                  | Visualizar impressão
                .abbr
                  .label {{ current.created_at | date }}
          section
            .divider
            .columns(v-if="current.modelo")
              item-col.my-1.col-12(
                label="doc_modelo.titulo",
                :value="current.modelo.titulo"
              )
              item-col.my-1.col-12(
                label="doc_modelo.descricao",
                :value="current.modelo.descricao"
              )
            .columns
              item-col.my-1.col-auto.col-sm-6(
                label="doc.ciencia_em",
                :value="current.ciencia_em | date"
              )
              item-col.my-1.col-auto.col-sm-6(
                label="doc.reincidente",
                :value="current.reincidente"
              )
              item-col.my-1.col-auto.col-sm-6(
                label="doc.prazo_regularizar",
                :value="current.prazo_regularizar"
              )
              item-col.my-1.col-auto.col-sm-6(
                label="doc.regularizar_em",
                :value="current.regularizar_em | date('DD/MM/YYYY')"
              )
          section(v-if="current.cadastro")
            .divider
            h5.h5 {{ "doc.cadastro" | tModel }}
            .columns
              item-col.my-1.col-4.col-sm-12(
                label="cadastro.numero",
                :value="current.cadastro.numero"
              )
              item-col.my-1.col-4.col-sm-12(
                label="cadastro.tipo",
                :value="`cadastro.tipo.${current.cadastro.tipo}` | enums"
              )
              item-col.my-1.col-12(
                v-if="current.cadastro.endereco_formatado",
                label="cadastro.endereco",
                :value="current.cadastro.endereco_formatado"
              )
            .columns
              .column.my-1.pb-2.col-12
                .item-col
                  .abbr {{ "cadastro.contribuinte" | tModel }}
                  .small
                    span {{ current.cadastro.contribuinte.cpf_cnpj | cpfCnpj }}
                    |
                    | - {{ current.cadastro.contribuinte.razao_social }}
          section(v-if="current.lista_servicos.length")
            .divider
            h1.h5 {{ "doc.lista_servicos" | tModel }}
            .columns.my-2.py-2.s-rounded.bg-gray.small(
              v-for="item in current.lista_servicos"
            )
              .column.col-auto
                b {{ item.item }}.{{ item.sub_item }}
              .column {{ item.descricao }}
          section(v-if="current.textos.length")
            .divider
            h5.h5 {{ "doc.textos" | tModel }}
            .my-2.p-2.bg-gray.s-rounded(v-for="texto in current.textos")
              .text-center {{ texto.titulo }}
              .text-long {{ texto.descricao }}
          section(v-if="current.planilhas.length")
            .divider
            h1.h5 {{ "doc.planilhas" | tModel }}
            planilhas(:planilhas="current.planilhas")
          section(v-if="current.cubs.length")
            .divider
            h1.h5 {{ "doc.cubs" | tModel }}
            .columns
              .column.col-8.col-sm-12
                table.table
                  thead
                    tr
                      th {{ "doc_cub.titulo" | tModel }}
                      th {{ "doc_cub.metros" | tModel }}
                      th {{ "doc_cub.valor_unitario" | tModel }}
                      th.text-right {{ "doc_cub.valor_total" | tModel }}
                  tbody
                    tr(v-for="cub in current.cubs")
                      td {{ cub.titulo }}
                      td {{ cub.metros | currency("", "m²") }}
                      td {{ cub.valor_unitario | currency("R$ ") }}
                      td.text-right {{ cub.valor_total | currency("R$ ") }}
          section(v-if="current.valores && current.valores.length")
            .divider
            h1.h5 {{ "doc.valores" | tModel }}
            .columns
              item-col.my-1.col-6.col-sm-12(
                v-for="valor in current.valores",
                :key="valor.tipo",
                :label="valor.titulo",
                :value="valor | formatValor"
              )
          section(v-if="current.valor_total")
            .divider
            .columns.pt-1
              .column
                h5.h5 {{ "doc.valor_total" | tModel }}
              .column.col-auto
                h5.h5 {{ current.valor_total | currency("R$ ") }}
          section(v-if="current.termo_textos.length")
            .divider
            h5.h5 {{ "doc.termo_textos" | tModel }}
            .my-2.p-2.bg-gray.s-rounded(v-for="texto in current.termo_textos")
              .text-center {{ texto.titulo }}
              .text-long {{ texto.descricao }}
          section(v-if="current.fiscal")
            .divider
            h5.h5 {{ "doc.fiscal" | tModel }}
            div {{ current.fiscal.nome }}
          section(v-if="current.comentarios")
            .divider
            h5.h5 {{ "doc.comentarios" | tModel }}
            comentarios(:comentarios="current.comentarios")
          .divider
          section.pb-2.mb-2
            .columns.align-center
              .column
              .column.col-auto
                a.btn.btn-primary(
                  v-if="current.permite_ciencia", @click="ciencia", :disabled="loading", :class="{ loading: loading }"
                )
                  span.pr-1 Li e estou ciente deste documento
                  i.fa.fa-check
              .column.col-auto.ml-2.text-right(
                v-if="current.permite_questionar"
              )
                router-link.btn.btn-link(:to="{ name: 'app.documentos.questionar' }")
                  i.fa.fa-question
                  span &nbsp; Tenho dúvida
              .column.col-auto.ml-2.text-right(
                v-if="current.permite_solicitar_vistoria_notificacao"
              )
                router-link.btn.btn-link(:to="{ name: 'app.documentos.regularizar' }")
                  i.fa.fa-check
                  span &nbsp; Regularizei
              .column.col-auto.ml-2.text-right(
                v-if="current.permite_solicitar_desconto"
              )
                router-link.btn.btn-link.text-success(:to="{ name: 'app.documentos.desconto' }")
                  i.fa.fa-money
                  span &nbsp; Solicitar desconto
              .column.col-auto.ml-2.text-right(
                v-if="current.permite_defesa_auto"
              )
                router-link.btn.btn-link.text-primary(:to="{ name: 'app.documentos.defesa' }")
                  i.fa.fa-shield
                  span &nbsp; Solicitar defesa
              .column.col-auto.ml-2.text-right(
                v-if="current.permite_solicitar_prazo_regularizar"
              )
                router-link.btn.btn-link(:to="{ name: 'app.documentos.prazo' }")
                  i.fa.fa-calendar
                  span &nbsp; Solicitar prazo

          router-view
</template>

<script>
import Planilhas from "./PlanilhaPreview.vue";
import Comentarios from "./components/comentarios/Comentarios.vue";
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: {
    docs: {
      state: ["current", "status"],
      actions: ["fetchOne", "fetchCiencia", "fetchSolicitarPrazo"],
      getters: ["loading"],
    },
  },

  components: { Planilhas, Comentarios },

  methods: {
    async ciencia() {
      try {
        await this.fetchCiencia(this.$route.params.id);
        this.$toaster.success("Ciência recebida com sucesso");
        this.$router.back();
      } catch (e) {
        toastErrors(e);
      }
    },
    async onSolicitarPrazo() {
      try {
        await this.fetchSolicitarPrazo(this.$route.params.id);
        this.$toaster.success("Solicitação de prazo realizada com sucesso");
        this.$router.back();
      } catch (e) {
        this.$toaster.error(e.message);
      }
    },
  },

  created() {
    this.fetchOne(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped>
.top-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  padding-top: 5px;
}
</style>
